// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  kind: __t.string(),
  plotX: __t.i32().name("plot_x"),
  plotZ: __t.i32().name("plot_z"),
  plotW: __t.u32().name("plot_w"),
  plotH: __t.u32().name("plot_h"),
  ownerIdentity: __t.identity().name("owner_identity"),
  claimedAt: __t.option(__t.timestamp()).name("claimed_at"),
});
